import { useState, useEffect, useRef } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import styles from './AdHocPrintFlat.module.css'

// ------ Services ------ //
import * as clientEventService from '../../../services/clientEventService'
import * as badgeService from '../../../services/badgeManagementService'
import * as kioskService from '../../../services/kioskService'
// components
import HoverButton from '../../../components/Miscellaneous/HoverButton'
import LoadingSpinner from "../../../components/Miscellaneous/LoadingSpinner"

const AdHocPrintFlat = () => {

    // State
    const [stylingForm, setStylingForm] = useState();
    const [templateSetting, setTemplateSetting] = useState(null);
    const [templateString, setTemplateString] = useState(null);
    const [htmlString, setHTMLString] = useState(null);
    const [blankForm, setBlankForm] = useState([])
    const [registrants, setRegistrants] = useState([])
    const [loaded, setLoaded] = useState(false)
    const [showAll, setShowAll] = useState(false)
    const location = useLocation()
    const navigate = useNavigate()
    const passedState = location.state
    const [clientEventInfo, setClientEventInfo] = useState({})
    const clientEventInfoRef = useRef(null);
    if (clientEventInfoRef === null || clientEventInfoRef.current === null) {
        if (!passedState || !passedState.clientName) {
            clientEventInfoRef.current = clientEventService.getClientEvent();
        }
        else {
            let passedData = {
                clientName: passedState.clientName,
                clientId: passedState.clientId,
                eventName: passedState.eventName,
                eventId: passedState.eventId,
            }
            clientEventInfoRef.current = passedData
        }

    }

    useEffect(() => {
        // reflects client/event selection changes made in Header.jsx without polling
        const handleClientEventChange = (e) => {
            // Update clientevent with every render when its value has changed.
            let savedClientEvent = clientEventService.getClientEvent()
            if (clientEventInfoRef.current && clientEventInfoRef.current.eventId !== undefined &&
                savedClientEvent && savedClientEvent.eventId !== undefined &&
                savedClientEvent.eventId !== clientEventInfoRef.current.eventId) {
                setClientEventInfo(savedClientEvent)
                clientEventInfoRef.current = savedClientEvent;
            }
        }
        window.addEventListener('clientEventChange', handleClientEventChange)
        return () => window.removeEventListener('clientEventChange', handleClientEventChange)
    }, [])

    useEffect(() => {
        if (!clientEventInfo?.clientId || !clientEventInfo?.clientName) return;

        const fetchData = async () => {
            // retrieve all elements print needs
            // set template settings
            const req = await createRequestBody();
            const templateSettings = await badgeService.retrieveFlatTemplate(req);
            if (templateSettings && templateSettings!== undefined) {
                setTemplateSetting(templateSettings);
                setTemplateString(templateSettings.templateString)
            }/* case "FullName_Combo":
            case "LastNameFirstName_Combo": */
            const defaultStylingForm = JSON.parse('{"FirstName":"","LastName":"","Organization":"","City":"","State":"","RegistrationType":"","Title":""' +
                ',"Country":"","Credentials":"","CityState_Combo":"","FullName_Combo":"","LastNameFirstName_Combo":"","Pronouns":"","RegistrationColor":"","Prefix":"","Suffix":"",'+
                '"Salutation": "", "DiscountCode": "", "EmailAddress": "","MemberType":"","Designation":"","Industry":"","Gender":"","Category":"","Ribbon":"","Region":"",' +
                '"Department":"","Diet":"","Allergy":"","ShirtSize":""}')
            setStylingForm(defaultStylingForm)
            setLoaded(true);
        }
        fetchData()

    }, [clientEventInfo])

    useEffect(() => {
        // store into local object
        if (!passedState || !passedState.clientName) {
            //let localclientevent = clientEventService.getClientEvent()
            if (clientEventInfoRef.current) {
                setClientEventInfo(clientEventInfoRef.current)
            }
        }
        else {
            let passedData = {
                clientName: passedState.clientName,
                clientId: passedState.clientId,
                eventName: passedState.eventName,
                eventId: passedState.eventId,
            }
            setClientEventInfo(passedData)
            clientEventInfoRef.current = passedData;
        }

    }, [])
    // --- REST --- //
    const createRequestBody = async () => {

        let requestBody = {}

        if (clientEventInfo.clientId && clientEventInfo.eventId) {
            requestBody =
            {
                "clientId": `${clientEventInfo.clientId}`,
                "eventId": `${clientEventInfo.eventId}`
            }
        }

        return await requestBody;
    }

    // Print   opens the full badge HTML document in a new window and prints it.
    // react-to-print cannot print an iframe's srcDoc content (it clones the
    // outer iframe DOM node, not the document inside it). Using window.open()
    // is the correct approach when the print target is a complete HTML string.
    const handlePrint = () => {
        if (!htmlString) return
        const printWindow = window.open('', '_blank')
        printWindow.document.open()
        printWindow.document.write(htmlString)
        printWindow.document.close()
        // Allow the badge template's window.onload script to run and
        // populate the badges-container before triggering the print dialog.
        setTimeout(() => {
            printWindow.focus()
            printWindow.print()
            printWindow.close()
        }, 500);
        stylingForm.clientName = clientEventInfo.clientName;
        kioskService.recordAdHocPrint(stylingForm);
        //reset form
        setHTMLString(null)
        setupForm()
    }
    useEffect(() => {
        setupForm()

    }, [templateString])
    const setupForm = async () => {
        if (templateSetting && templateString && stylingForm) {
            let stylingFields = stylingForm;
            let filteredResults = []
            // apply filtering, only want name, clear value
            // check if there's a cSSValues as well
            Object.keys(stylingFields).forEach(function (stylingFieldName) {
                let tempHolder = {
                    fieldName: stylingFieldName,
                    fieldValue: '',
                }
                filteredResults.push(tempHolder)
                stylingFields[stylingFieldName] = '';
            });
            stylingFields.clientId = clientEventInfo.clientId;
            stylingFields.eventId = clientEventInfo.eventId;
            // store clear entries
            // clear out entries
            setStylingForm(stylingFields)
            setBlankForm(filteredResults);
            
        }
    }
    const handleShowAll = async e => {
        e.preventDefault()
        setShowAll(!showAll);
    }
    useEffect(() => {
        if (registrants && registrants.length > 0) {
            let jsonObject = JSON.stringify(registrants);
            if (jsonObject && jsonObject !== '[]') {
                let newHTML = JSON.parse(templateString).replace("\"%ATTENDEEINFO%\"", JSON.stringify(jsonObject));
                //console.log(newHTML);
                setHTMLString(newHTML);
            }
        }

    }, [registrants])
    const handleChange = (e, index) => {
        let temp = stylingForm;
        if (temp) {
            //update entry
            temp[e.target.name] = e.target.value;
        }
        setStylingForm(temp)
        let tempHolder = {
            fieldName: e.target.name,
            fieldValue: e.target.value,
        }
        setBlankForm((prevState) => {
            const newState = [...prevState]
            newState[index] = tempHolder
            return newState
        });
        let regTemp = [
            stylingForm
        ]
        setRegistrants(regTemp)
    }
    const isFormInvalid = () => {
        return (templateString && templateString !== undefined && stylingForm)
    }
    return (
        <>
            {loaded ?
        <div className="page-area">
            <h1>AdHoc Flat Print</h1>
                    <h2>{clientEventInfo.clientName} ({clientEventInfo.eventName})</h2>
                    <h4>Note: AdHoc template setup may not have all fields, but all fields are available. </h4><br />
                    <button className={styles.backButton} onClick={() => navigate(-1)}> Back </button>
                    <div className={styles.container}>

                        <div className={styles.leftPane}>
                            {blankForm && blankForm.length > 0 ?
                                showAll ? 
                                    <>
                                        <div className={styles.containerSmaller}>
                                            <button disabled={!isFormInvalid()} className={styles.rightButton} onClick={handlePrint}>
                                                Print
                                            </button>
                                        </div>
                                        {blankForm.map((blankFormField, index) => (
                                            <>
                                                <div className={styles.inputRow}>
                                                    <label className={styles.leftLabel}>{blankFormField.fieldName}: </label>
                                                    <input
                                                        type="text"
                                                        autoComplete="off"
                                                        value={blankFormField.fieldValue}
                                                        name={blankFormField.fieldName}
                                                        onChange={(e) => handleChange(e, index)}
                                                        className={styles.rightInput}
                                                        key={index}
                                                    />
                                                </div>
                                            </>
                                        ))}
                                    </>
                                    :
                                    <>
                                        <div className={styles.containerSmaller}>
                                            <button disabled={!isFormInvalid()} className={styles.rightButton} onClick={handlePrint}>
                                                Print
                                            </button>
                                        </div>
                                        {blankForm.map((blankFormField, index) => (
                                            <>
                                                {index < 13 ? 
                                                    <div className={styles.inputRow}>
                                                        <label className={styles.leftLabel}>{blankFormField.fieldName}: </label>
                                                        <input
                                                            type="text"
                                                            autoComplete="off"
                                                            value={blankFormField.fieldValue}
                                                            name={blankFormField.fieldName}
                                                            onChange={(e) => handleChange(e, index)}
                                                            className={styles.rightInput}
                                                            key={index}
                                                        />
                                                    </div>
                                                    : null}
                                            </>
                                        ))}
                                    </>
                        :
                        <div>
                            No matching results
                        </div>
                            }
                            
                            <div className={styles.containerSmaller}>
                                <button className={styles.button} onClick={handleShowAll} title=
                                    {showAll ? 'Show fields that are most edited.' : 'Show all fields that can be edited.'}>
                                    {showAll ? 'Show \'Main Fields\'...' : 'Show \'All Fields\'...'}
                                </button>
                            </div>
                            <div className={styles.containerSmaller}>
                                <button disabled={!isFormInvalid()} className={styles.rightButton} onClick={handlePrint}>
                                    Print
                                </button>
                            </div>
                           
                        </div>
                        <div className={styles.rightPane}>
                            <div className={styles.centerPrint}>
                                <iframe srcDoc={htmlString} title="Badge Content Preview" id='iframeBadge'
                                    sandbox="allow-scripts allow-modals"
                                    style={{ width: '100%', height: '500px', border: '1px solid #ccc' }}
                                />
                            </div>

                        </div>
            </div>
        </div>
        :
<LoadingSpinner />
        }
        </>
    );
}

export default AdHocPrintFlat;